<template>
  <div class="harvest-dashboard-banner">
    We have had major announcements, excitement and momentum in the community and we have so much more to look forward to. We want to make Community Tokenization and
    <a
      href="https://twitter.com/BullsApesProj/status/1608551219542327298"
      target="_blank"
    >Ape Invasion</a> as amazing as possible and will be focusing all of our attention to meet those expectations.
    <br><br>This will mean that we will be postponing the Weird Worlds Rolling mint by
    <b>at least 90 days.</b> We know there have been many questions on the pricing and having enough time to collect Methane to mint a world. We hope you use this extra time to collect and save up.
  </div>
</template>
<script>
export default {

}
</script>